/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Modal, Table, Button, Spin } from 'antd'
import { SelectOutlined, DeleteOutlined } from '@ant-design/icons'
import { useSelector, useDispatch } from 'react-redux'

import { onListSupplierVatInvoiceBySupplierName } from 'redux/actions'
import { addCommas } from 'utils'

import InlineInput from 'components/InlineInput'

const SearchSupplierVatInvoicePopup = ({
  visible,
  onClick,
  onCancel,
  onDeleteItem,
  supplierName = '',
}) => {
  const [list, setList] = useState([])
  const [name, setName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [filteredList, setFilteredList] = useState([])
  const dispatch = useDispatch()
  let listSupplierVatInvoiceBySupplierName = useSelector(
    (state) => state.listSupplierVatInvoiceBySupplierName
  )

  useEffect(() => {
    if (visible && supplierName !== '') {
      dispatch(onListSupplierVatInvoiceBySupplierName(supplierName))
    }
    setName(supplierName)
  }, [visible])

  useEffect(() => {
    const { error, loading, finished, data, trace } =
    listSupplierVatInvoiceBySupplierName
    if (!error && !loading && finished) {
      setList(data)
      setFilteredList(data)
      setIsLoading(false)
    }
    if (error && !loading) {
      Modal.error({
        centered: true,
        title: 'ตรวจสอบ',
        content: `${trace.message}`,
      })
      setIsLoading(false)
    }
  }, [listSupplierVatInvoiceBySupplierName])

  const handleSearch = (searchValue) => {
    const _list = [...list]
    const filteredData = _list.filter(
      ({ supplier_invoice_no, supplier_name }) => {
        supplier_invoice_no = supplier_invoice_no.toString().toLowerCase()
        supplier_name = supplier_name.toString().toLowerCase()
        return (
          supplier_invoice_no.includes(searchValue.toLowerCase()) ||
          supplier_name.includes(searchValue.toLowerCase())
        )
      }
    )
    setFilteredList(filteredData)
  }

  const fetchList = (value) => {
    setIsLoading(true)
    dispatch(onListSupplierVatInvoiceBySupplierName(value))
  }

  const onClosePopUp = () => {
    clearInput()
    onCancel()
  }

  const onSelectItem = (record) => {
    onClick(record)
    // clearInput()
  }

  const clearInput = () => {
    setList([])
    setFilteredList([])
    setSearchText('')
  }

  const tableColumns = [
    {
      title: '',
      dataIndex: '',
      key: 'x',
      width: '30px',
      render: (_, record) => {
        return (
          <Button
            size="small"
            type="primary"
            icon={<SelectOutlined />}
            onClick={() => onSelectItem(record)}
          />
        )
      },
    },
    {
      title: 'เลขที่ใบวางบิล',
      dataIndex: 'supplier_invoice_no',
      key: 'supplier_invoice_no',
      width: '170px',
    },
    {
      title: 'วันที่ซื้อ',
      dataIndex: 'date',
      key: 'date',
      width: '100px',
    },
    {
      title: 'ชื่อผู้ขาย',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      width: '250px',
      render: (text) => <div className="break-word">{text}</div>,
    },
    {
      title: 'ยอดรวม',
      dataIndex: 'supplier_invoice_total',
      key: 'supplier_invoice_total',
      width: '110px',
      render: (text) => (
        <div className="text-align-right pr-2">{addCommas(text)}</div>
      ),
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      width: '40px',
      render: (_, record) => {
        return (
          <Button
            size="small"
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => onDeleteItem(record)}
          />
        )
      },
    },
  ]

  return (
    <Modal
      visible={visible}
      width="950px"
      onCancel={onClosePopUp}
      footer={null}
      title={
        <div>
          <InlineInput
            onSearch={(value) => {
              fetchList(value)
            }}
            inputOption="search"
            label="ค้นหา"
            placeholder="ใส่ชื่อผู้ขาย"
            disabled
            value={name}
            width="280px"
            onChange={(event) => {
              setName(event.target.value.toUpperCase())
            }}
          />
        </div>
      }
    >
      <Spin spinning={isLoading}>
        <Table
          rowKey={(record) => `id+${record.code}`}
          dataSource={filteredList}
          columns={tableColumns}
          style={{ height: '440px' }}
          scroll={{ y: 360 }}
          size="small"
          pagination={{
            position: ['bottomRight'],
            simple: true,
            defaultPageSize: 10,
          }}
        />
        <div style={{ position: 'absolute', bottom: '-8px' }}>
          <div className="mb-1">
            <InlineInput
              onSearch={(value) => {
                handleSearch(value)
              }}
              inputOption="search"
              label="กรองข้อมูล"
              placeholder="กรอง เลขที่ใบวางบิล"
              value={searchText}
              width="280px"
              onChange={(event) => {
                setSearchText(event.target.value.toUpperCase())
              }}
            />
          </div>
        </div>
      </Spin>
    </Modal>
  )
}

export default SearchSupplierVatInvoicePopup
